import styled, { css } from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { fontSizes, fontWeights } from "../../../design-system/tokens/typography";

export const Bar = styled.div`
  display: flex;
  gap: ${spacing[1]};
  width: 100%;
`;

interface ChipProps {
  $active: boolean;
  $accent?: string;
}

export const Chip = styled.button<ChipProps>`
  flex: 1 1 0;
  min-width: 0;
  height: ${spacing[7]}; // 28px
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${borderRadius.lg};
  border: 1px solid ${rawColors.stroke[200]};
  background: ${rawColors.structural.white};
  color: ${rawColors.text.mediumEmphasis};
  font-size: ${fontSizes["11"]};
  font-weight: ${fontWeights.bold};
  cursor: pointer;

  // :hover outranks the active rule below, so an active chip under the pointer would lose its fill.
  ${({ $active }) =>
    !$active &&
    css`
      &:hover {
        background: ${rawColors.structural[100]};
      }
    `}

  &:focus-visible {
    outline: 2px solid ${rawColors.text.interactive};
    outline-offset: 1px;
  }

  ${({ $active, $accent }) =>
    $active &&
    ($accent
      ? css`
          color: ${$accent};
          border-color: ${$accent};
          background: color-mix(in srgb, ${$accent} 12%, ${rawColors.structural.white});
        `
      : css`
          color: ${rawColors.text.white};
          border-color: ${rawColors.text.highEmphasis};
          background: ${rawColors.brand.primaryDarker};
        `)}
`;
